import { createContext, useContext } from 'react'
import type { Answers, StoredResult } from '../types'

export interface SessionValue {
  activated: boolean
  answers: Answers
  currentQuestion: number
  result: StoredResult | null
  activate: () => void
  setAnswer: (questionId: string, optionId: string) => void
  setCurrentQuestion: (index: number) => void
  calculateResult: (answersOverride?: Answers) => Promise<StoredResult | null>
  loadSharedResult: (answers: Answers, result: StoredResult) => void
  restart: () => void
  answeredCount: number
  isComplete: boolean
}

export const SessionContext = createContext<SessionValue | null>(null)

export function useSession() {
  const value = useContext(SessionContext)
  if (!value) throw new Error('useSession must be used inside SessionProvider')
  return value
}
